import { AnyAction } from '@reduxjs/toolkit';
import { IDetailsOrderData, OrderTabsEnum } from 'types/Order.types';
import { INIT_DETAILS_ORDER_DATA } from 'store/Order/reducers/order';
import {
  COMPANY_CHANGED,
  RESET_QUOTATION_ORDER,
  SET_QUOTATION_ORDER_ACTIVE_TAB,
  SET_QUOTATION_ORDER_SUPPLIER_DETAILS,
  SET_SELECTED_QUOTATION_LINE_IDS,
  SYNC_QUOTATION_ORDER_SUPPLIERS,
} from 'store/constants';

// State for turning quotation lines into orders. Kept apart from orderInfo
// because a quotation can span several suppliers, and each supplier gets its
// own set of order details (one order is created per supplier).
export interface IQuotationOrderReducerState {
  activeTab: OrderTabsEnum;
  selectedLineIds: number[];
  detailsOrderDataBySupplier: Record<number, IDetailsOrderData>;
}

const INIT_STATE: IQuotationOrderReducerState = {
  activeTab: OrderTabsEnum.Products,
  selectedLineIds: [],
  detailsOrderDataBySupplier: {},
};

const quotationOrderReducer = (state = INIT_STATE, action: AnyAction) => {
  switch (action.type) {
    case SET_QUOTATION_ORDER_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };
    case SET_SELECTED_QUOTATION_LINE_IDS:
      return {
        ...state,
        selectedLineIds: action.payload,
      };
    case SET_QUOTATION_ORDER_SUPPLIER_DETAILS:
      return {
        ...state,
        detailsOrderDataBySupplier: {
          ...state.detailsOrderDataBySupplier,
          [action.payload.supplierId]: action.payload.detailsOrderData,
        },
      };
    case SYNC_QUOTATION_ORDER_SUPPLIERS: {
      const supplierIds: number[] = action.payload;
      const synced: Record<number, IDetailsOrderData> = {};
      for (const supplierId of supplierIds) {
        synced[supplierId] =
          state.detailsOrderDataBySupplier[supplierId] ??
          INIT_DETAILS_ORDER_DATA;
      }
      return {
        ...state,
        detailsOrderDataBySupplier: synced,
      };
    }
    case RESET_QUOTATION_ORDER:
    case COMPANY_CHANGED:
      return {
        ...INIT_STATE,
      };
    default:
      return state;
  }
};

export default quotationOrderReducer;
